import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthBootstrap } from "@/lib/useAuthBootstrap";

// Minimal, chrome-free shell used by TestRunner. Header and footer are owned
// by the TestRunner itself so it can show the timer prominently and prevent
// accidental navigation away during an exam.
export function FullscreenLayout() {
  const location = useLocation();
  // Wait for the access token to be re-minted from the refresh cookie before
  // deciding. A FRESH TAB — the "Preview as student" tab, or any direct load /
  // reload of the run page — starts with no in-memory token; checking
  // isLoggedIn() synchronously here would bounce it to /login mid-bootstrap.
  // Mirror AppLayout: hold on "bootstrapping", only redirect on "unauthed".
  const phase = useAuthBootstrap();

  if (phase === "bootstrapping") {
    return (
      <div
        role="status"
        aria-live="polite"
        className="flex min-h-screen flex-col items-center justify-center bg-background"
      >
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        <p className="mt-3 text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (phase === "unauthed") {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: { pathname: location.pathname, search: location.search },
        }}
      />
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <main id="main" tabIndex={-1} role="main" className="flex flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
